import React from "react";
import { useSelector } from "react-redux";
import { RootState, ModalDetails } from "types";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { createHash } from "utils/helperFunctions";
import { IconButton, Tooltip } from "@mui/material";

interface SendReqBtnProps {
  action: () => void;
  gameId: string;
  cb: (data: ModalDetails) => void;
  tip?: string;
}

function SendReqBtn({
  action,
  gameId,
  cb,
  tip = "Request To Join Game",
}: SendReqBtnProps) {
  const user = useSelector((state: RootState) => state.user.user);
  const requests = useSelector(
    (state: RootState) => state.requests.sentRequests,
  );

  const checkExistingRequest = async () => {
    if (!user?.uid) return;
    const reqId = createHash(user.uid + gameId);
    const request = requests[reqId];
    let status = "confirm";
    if (request) status = request.status;
    return cb({
      open: true,
      status,
      reqData: request || {},
    });
  };

  return (
    <Tooltip title={tip} placement="top">
      <IconButton
        onClick={() => {
          action();
          checkExistingRequest();
        }}
        color="success"
        size="small"
      >
        <PersonAddIcon />
      </IconButton>
    </Tooltip>
  );
}

export default SendReqBtn;
